// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { cartPageTemplateBreakpoint } from "@pace/App/Components/Cart/CartPageTemplate";
import { xCheckoutInnerContainerStyles } from "@pace/App/SharedStyles/CheckoutPageStyles";
import { orderInformationStyles } from "@pace/Overrides/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { ellipsis, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

orderInformationStyles.orderDetails = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 22px;
        > ${StyledWrapper} {
            width: 317px;
        }
        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            gap: 16px;
            > ${StyledWrapper} {
                width: calc(50% - 8px);
            }
        }
    `,
};

orderInformationStyles.orderNumberHeading = {
    variant: "h2",
};

orderInformationStyles.orderConfirmationShippingInformation = {
    shippingInformationAddressGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    shippingAddressTitle: {
        variant: "h6",
        as: "h3",
        css: css`
            line-height: 26px;
            margin-bottom: 12px;

            @media print {
                font-size: 12px;
            }
        `,
    },
};

orderInformationStyles.orderConfirmationBillingInformation = {
    billingInformationGridContainer: {
        gap: 0,
    },
    billingAddressTitle: {
        variant: "h6",
        as: "h3",
        css: css`
            line-height: 26px;
            margin-bottom: 12px;

            @media print {
                font-size: 12px;
            }
        `,
    },
    billingCreditCardAddressTitle: {
        variant: "h6",
        as: "h3",
        css: css`
            line-height: 26px;
            margin-bottom: 12px;

            @media print {
                font-size: 12px;
            }
        `,
    },
    billingInformationBillingAddressGridItem: {
        width: [12, 12, 6, 6, 6],
        printWidth: 12,
        css: css`
            flex-direction: column;
        `,
    },
    billingInformationCreditCardAddressGridItem: {
        width: [12, 12, 6, 6, 6],
        printWidth: 12,
        css: css`
            flex-direction: column;
        `,
    },
};

orderInformationStyles.sectionTwoColums = {
    ...xCheckoutInnerContainerStyles.sectionTwoColums,
    css: css`
        display: flex;
        column-gap: 22px;
        align-items: baseline;
        > div {
            width: 50%;
        }
    `,
};

orderInformationStyles.value = {
    ...xCheckoutInnerContainerStyles.value,
    css: css`
        display: block;
        word-wrap: break-word;
        white-space: wrap;
        & + ${TypographyStyle} {
            margin-top: 8px;
        }

        ${xScreen("lte", "sm")} {
            ${ellipsis(2)}
        }
    `,
};

orderInformationStyles.container = xCheckoutInnerContainerStyles.container;
orderInformationStyles.section = xCheckoutInnerContainerStyles.section;
orderInformationStyles.sectionTitle = xCheckoutInnerContainerStyles.sectionTitle;
orderInformationStyles.hr = xCheckoutInnerContainerStyles.hr;
orderInformationStyles.label = xCheckoutInnerContainerStyles.label;
orderInformationStyles.value = xCheckoutInnerContainerStyles.value;
